import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { extractionSummaryChange } from "../../../api";
import Navbar from "../../../containers/navbar";
import MainHeader from "../../../containers/header";
import Header from "../../../containers/content_header";
import ReportTemplate from "../../../containers/report_template";
import ErrorModal from "../../../containers/error_modal";

const ExtractionSummary = ({ ...props }) => {
  const { loc, locationName, widthIsSmall, username } = props;
  const [extractionList, setExtractionList] = useState([]);
  const [allExtractionList, setAllExtractionList] = useState([]);
  const [filteredData, setfilteredData] = useState([]);
  const [itemKeys, setItemKeys] = useState([]);
  const [lambdaError, setLambdaError] = useState("");
  const [isListLoading, setIsListLoading] = useState(false);
  const [isdownloadLoading, setIsdownloadLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const openErrRef = useRef();
  const closeErrRef = useRef();

  const hasCluster = extractionList?.length > 0 && extractionList[0]?.cluster !== null && extractionList[0]?.cluster !== undefined && extractionList[0]?.cluster !== "";

  const tableHeads = [
    "transfer no",
    "store",
    "item",
    "item desc",
    "extract id",
    "extract qty",
    "to loc qty",
    "create date",
    "user id",
    ...(hasCluster ? ["cluster"] : []),
  ];

  const isFirstRender = useRef(true);

  useEffect(() => {
    getExtractionSummary();

    if (isFirstRender.current) {
      isFirstRender.current = false
      return;
    }
  }, [currentPage, searchText]);

  const getExtractionSummary = async () => {
    try {
      setExtractionList([]);
      setIsListLoading(true);
      let payload = {
        loc: loc,
        start: currentPage * 10,
        length: 10,
        search_key: searchText,
        file: false,
        user_id: String(username),
      };
      const resData = await extractionSummaryChange(payload);

      if (resData) {
        if (resData?.status === "error") {
          setLambdaError(resData?.error_message);
          openErrRef.current.click();
        } else {
          if (Object.keys(resData?.body?.records || {})?.length) {
            const hasCluster = resData?.body?.records?.length > 0 && resData.body.records[0]?.cluster !== null && resData.body.records[0]?.cluster !== undefined && resData.body.records[0]?.cluster !== "";

            let formattedData = resData?.body?.records?.map((item) => {
              return {
                transfer_no: item?.transfer_no,
                store: item?.store,
                item: item?.item,
                item_desc: item?.item_desc,
                extract_id: item?.extract_id,
                extract_qty: item?.extract_qty,
                to_loc_qty: item?.to_loc_qty,
                create_date: item?.create_date,
                user_id: item?.user_id,
                ...(hasCluster ? { cluster: item?.cluster } : {}),
              };
            });
            setExtractionList(formattedData);
            setAllExtractionList(formattedData);
            setfilteredData(formattedData);
            setItemKeys(Object.keys(formattedData[0]));
            setTotalRecords(resData?.body?.totalRecords);
          } else {
            setTotalRecords(resData?.body?.totalRecords);
          }
        }
        setIsListLoading(false);
      } else {
        // setLambdaError("Something went wrong");
        // openErrRef.current.click();
        setIsListLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLambdaError(error);
      openErrRef.current.click();
      setIsListLoading(false);
    }
  };

  const onDownLoadS3Url = async () => {
    try {
      setIsdownloadLoading(true);
      let payload = {
        loc: loc,
        start: 0,
        length: 0,
        search_key: searchText,
        file: true,
        user_id: String(username),
      };
      const resData = await extractionSummaryChange(payload);
      if (resData) {
        if (resData?.status === "error") {
          setLambdaError(resData?.error_message);
          openErrRef.current.click();
        } else {
          if (resData?.body?.file_url) {
            window.open(resData?.body?.file_url);
          }
        }
      }
      //  else {
      //   setLambdaError("Something went wrong");
      //   openErrRef.current.click();
      // }
      setIsdownloadLoading(false);
    } catch (error) {
      console.log(error);
      setLambdaError(error);
      openErrRef.current.click();
      setIsdownloadLoading(false);
    }
  };

  const addPageData = (pageData) => {
    setExtractionList(pageData);
  };

  return (
    <>
      <MainHeader />
      <Navbar />
      <div
        className="lpn-hm d-flex flex-column"
        style={{ padding: widthIsSmall ? "0px" : "8px 24px" }}
      >
        <Header
          text={`${loc} - ${locationName}`}
          headerText={"Extraction Summary"}
        />
        <ReportTemplate
          widthIsSmall={widthIsSmall}
          tableHeads={tableHeads}
          itemKeys={itemKeys}
          data={extractionList}
          isTableLoading={isListLoading}
          loc={loc}
          buttonName={"Download Extraction Summary"}
          filePrefix={"extraction_summary"}
          searchText={(text) => setSearchText(text)}
          allData={allExtractionList}
          addPageData={addPageData}
          pageCount={10}
          filteredData={filteredData}
          totalRecords={totalRecords}
          type={"paginationFromDb"}
          changePage={(pageNo) => setCurrentPage(pageNo)}
          onDownloadUrl={onDownLoadS3Url}
          isdownloadLoading={isdownloadLoading}
        />
        <ErrorModal
          id={"errorModal"}
          openRef={openErrRef}
          closeRef={closeErrRef}
          headerColor={"red"}
          msg={lambdaError}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loc: state?.auth?.user?.loc,
    locationName: state?.auth?.user?.locationName,
    widthIsSmall: state?.auth?.widthIsSmall,
    username: state?.auth?.user?.loginName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ExtractionSummary);
